// extracted by mini-css-extract-plugin
export default {"oldPrice":"LJKOOQ"};